import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import getFileExtension from "../../../shared/utils/getFileExtension";

export const insertPostAttachment = async (data) => {
  const { file, postId, title } = data;
  const form = new FormData();

  form.append(
    "dados",
    `[${JSON.stringify({
      postagemid: postId,
      nome: title,
      link: data.url || "",
      extensao: file
        ? file.extension || getFileExtension(file.name)
        : data.extension || "",
    })}]`
  );
  if (file) {
    form.append("file", file);
  }
  const res = await axios.middleware.post(
    "/aluno.asmx/Inserir_Anexo_Postagem",
    form
  );
};

export const useInsertPostAttachment = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: insertPostAttachment });
};
